import {Pipe, PipeTransform} from '@angular/core';

@Pipe({standalone: true, name: 'invoiceNumberPipe'})
export class InvoiceNumberPipe implements PipeTransform
{

  transform(invoiceNumberPrefix: string, invoiceNumber: number): string
  {
    if (!invoiceNumber)
    {
      return '';
    }

    if (invoiceNumberPrefix)
      return invoiceNumberPrefix + '-' + invoiceNumber;
    else
      return invoiceNumber + '';
  }

}
